import {Inject, Injectable, Renderer2} from "@angular/core";
import {DOCUMENT} from "@angular/common";
import {ScriptOptionsModel} from "../models/script-options.model";

@Injectable({
	providedIn: "root",
})
export class ScriptLoaderService {

	private usedSources: string[] = [];

	constructor(@Inject(DOCUMENT) private readonly document: Document) {
	}

	public loadScript(scriptOptions: ScriptOptionsModel, renderer: Renderer2): Promise<boolean> {
		return new Promise((resolve, reject) => {
			if (this.usedSources.includes(scriptOptions.src)) {
				resolve(true);
				return;
			}

			this.usedSources.push(scriptOptions.src);
			const script: any = renderer.createElement("script");
			script.type = scriptOptions.type;
			script.src = scriptOptions.src;
			script.async = scriptOptions.async;
			script.charset = scriptOptions.charset;

			script.addEventListener("load", () => {
						resolve(true);
					},
					{
						once: true
					}
			);

			script.addEventListener("error", (event: any) => {
						reject(false);
					},
					{
						once: true
					}
			);

			renderer.appendChild(this.document.body, script);
		});
	}
}